export const RENTAL_CHANGE_SUPER = 'super'
export const RENTAL_CHANGE_HIGH = 'high'
export const RENTAL_CHANGE_MEDIUM = 'medium'
export const RENTAL_CHANGE_LOW = 'low'
